angular.module('gym.contacts').controller('NewContactsCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "$filter", "$document", "$timeout", "forms", "flash", "loadingAnimation", "contacts", "NewContactService", "FormFieldDisplayingService", "EmploymentService", "GTMService", "relationshipForContact", "mobileAppAccessRequest", function($scope, $rootScope, $state, $stateParams, $filter, $document, $timeout, forms, flash, loadingAnimation, contacts, NewContactService, FormFieldDisplayingService, EmploymentService, GTMService, relationshipForContact, mobileAppAccessRequest) {
  var formattedContactType, isPermissionsAvailable;
  $scope.forms = _.filter(forms, function(form) {
    return form.show_on_new_record;
  });
  $scope.editContact = NewContactService.get({
    relationshipForContact: relationshipForContact,
    mobileAppAccessRequest: mobileAppAccessRequest
  });
  $scope.contactType = $stateParams.contactType;
  $scope.units = $rootScope.gym.units;
  $scope.permissions = EmploymentService.get().permissions;
  $timeout(function() {
    if ($stateParams.section && angular.element(`#${$stateParams.section}`)[0]) {
      return $document.scrollToElement(angular.element(`#${$stateParams.section}`));
    }
  }, 50);
  $rootScope.setAppFooterVisible(false);
  $scope.$on('$destroy', function() {
    return $rootScope.setAppFooterVisible(true);
  });
  if (relationshipForContact.id) {
    $scope.editContact.add_contact_relationship_for_id = relationshipForContact.id;
    $scope.editContact.add_contact_relationship_for_type = decodeURIComponent($stateParams.relationshipForType);
  }
  formattedContactType = function() {
    var type;
    type = $stateParams.contactType === 'non_attending_contacts' ? 'non-attending' : $stateParams.contactType.slice(0, -1);
    return $filter('capitalize')(type);
  };
  GTMService.trackPage(formattedContactType());
  $scope.availableAsFormField = function(form) {
    var ref;
    return (ref = form.name) !== 'memberships' && ref !== 'member_styles';
  };
  isPermissionsAvailable = function(field) {
    switch (field.name) {
      case 'owner_id':
        return $scope.permissions.change_contact_owner;
      default:
        return true;
    }
  };
  $scope.isFieldAvailable = function(field) {
    var contactType;
    contactType = $stateParams.contactType.slice(0, -1);
    return FormFieldDisplayingService.isDisplaying(contactType, field) && !field.read_only && !field.archived && isPermissionsAvailable(field);
  };
  $scope.availableFields = function(fields) {
    return fields.filter(function(item) {
      return $scope.isFieldAvailable(item);
    });
  };
  $scope.isFormOptional = function(form) {
    var fields;
    fields = $scope.availableFields(form.fields);
    return _.every(fields, function(field) {
      return !field.required;
    });
  };
  $scope.fieldClass = function(field, fields) {
    if (field.name === 'address' || field.label === 'Address' || fields.length === 1) {
      return 'col-md-12';
    }
    return 'col-md-6';
  };
  $scope.membershipExpirationDate = function(membership) {
    if (!membership.term_number) {
      return 'N/A';
    }
    return moment(membership.start_date).add(membership.term_number, membership.term_unit).format('D MMM YYYY');
  };
  $scope.hideError = function(field, form) {
    var ref;
    return (ref = $scope.editContact[form.name].errors) != null ? ref[field.name] = [] : void 0;
  };
  $scope.confirmedArchiveInstance = function(instance, form, index) {
    return $scope.editContact.memberships = NewContactService.removeFormInstance('memberships', index);
  };
  $scope.addMembership = function() {
    NewContactService.set($scope.editContact);
    return $state.go('gym.contacts.membership', {
      contactId: 'new'
    });
  };
  $scope.addStyle = function() {
    NewContactService.set($scope.editContact);
    return $state.go('gym.contacts.newContactStyle');
  };
  $scope.removeStyle = function(instance, form, index) {
    return $scope.editContact.member_styles = NewContactService.removeFormInstance('member_styles', index);
  };
  $scope.save = function() {
    GTMService.trackPage(formattedContactType(), 'attempt');
    loadingAnimation.show();
    $scope.editContact.rootObjectName = 'contact';
    return contacts.post($scope.editContact).then(function(contact) {
      GTMService.trackPage(formattedContactType(), 'success');
      NewContactService.clear();
      flash.success = `Contact ${contact.name} created`;
      $state.go('gym.contacts.edit', {
        contactId: contact.id
      });
      $scope.$emit('access_requests:pending_count:reload');
      return $document.scrollTop(0);
    }, function(contact) {
      GTMService.trackPage(formattedContactType(), 'error');
      loadingAnimation.hide();
      if (contact.data) {
        $scope.editContact = angular.extend($scope.editContact, contact.data, {
          memberships: $scope.editContact.memberships,
          member_styles: $scope.editContact.member_styles
        });
        return flash.error = "Create failed. Please fix the errors below";
      } else {
        return flash.error = "There was an error processing the request.";
      }
    });
  };
  return $scope.cancel = function() {
    NewContactService.clear();
    return $state.go('gym.contacts.list');
  };
}]);
